import { Button, TextDS2 } from '@monorepo-hol/design-system';
import { ImageWrapper } from '@monorepo-hol/design-system';
import Link from 'next/link';

export default function NotFoundPage() {

  return (
    <div className="flex flex-col px-4 py-16 items-center justify-center container w-full lg:w-2/5 ">
      <ImageWrapper
        src="/img/page-404.png"
        sizes="100vw"
        alt="404-icon"
        className="w-48 h-[9.375rem] lg:w-80 lg:h-[15.625rem]"
      />
      <div className="pt-8 flex flex-col justify-center items-center">
        <TextDS2
          agDesktop="Desktop/Title 1/Extra Bold"
          agMobile="Mobile/Title/Extra Bold"
          color="Neutral/400"
        >
          Halaman tidak ditemukan
        </TextDS2>
        <span className="text-[1.375rem] lg:text-[1.8125rem] text-neutral-400 font-extrabold text-center leading-[1.875rem] lg:leading-10" />
        <p className="pt-2 font-inter font-medium text-neutral-300 text-center text-sm lg:text-base leading-6 lg:leading-[1.625rem]">
          Maaf, halaman yang dituju tidak tersedia. Mohon cek ulang tautan pada{' '}
          browser atau hubungi{' '}
          <a
            href="mailto:customer@hukumonline.com"
            className="text-primary-main"
          >
            customer@hukumonline.com
          </a>
        </p>
        <div className="mt-6">
          <Button variant="outlined" className="leading-6 rounded-[5px]">
            <Link
              href="https://www.hukumonline.com/"
              className="text-primary-main font-bold text-sm leading-6"
            >
              Halaman Utama
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
